module.exports = __webpack_public_path__ + "img/symbol_4.3d04b70b.png";